@if (sortOrder == 0) {
	<i class="mdi mdi-unfold-more-horizontal" aria-hidden="true"></i>
} @else if (sortOrder === 1) {
	<i class="mdi mdi-chevron-up" aria-hidden="true"></i>
} @else if (sortOrder === -1) {
	<i class="mdi mdi-chevron-down" aria-hidden="true"></i>
}
